import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import LogInForm from './components/LogInForm';
import LinkWalmartAccountSelect from './components/LinkWalmartAccountSelect';
import { LoginHeader, setFavicon } from '../../../shared/components/domainSupport';

const LogIn = () => {
  const { loggedIn, loggingIn } = useSelector(state => state.authentication);
  const [loginStarted, setLoginStarted] = useState(false);
  const isWalmartLink = window.location.pathname === '/link/walmart/marketplace';

  // Only show the account selector after a login on this page (a stale stored session is cleared by the form).
  useEffect(() => {
    if (loggingIn) {
      setLoginStarted(true);
    }
  }, [loggingIn]);

  const showAccountSelect = isWalmartLink && loggedIn && loginStarted;

  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="account__card">
          {setFavicon()}
          <LoginHeader />
          {showAccountSelect ? <LinkWalmartAccountSelect /> : <LogInForm onSubmit />}
        </div>
      </div>
    </div>
  );
};

export default LogIn;

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/components/form.scss to add styles
